export const PASSPORT_SERIES_LENGTH = 4;
export const PASSPORT_NUMBER_LENGTH = 6;
